/**
 * @constructor
 * @param {SpinReels} spinReels
 * @returns {ReelsSpinner}
 */
export default function ReelsSpinner(spinReels) {
    this._spinReels = spinReels;

    this._onStart = function() {};
    /** @param {ReelManager} reelManager */
    this._onStop = function(reelManager) {};

    /** @param {ReelManager} reelManager */
    this._onBrakeDown = function(reelManager) {};

    /** @param {ReelManager} reelManager */
    this._onBrakeUp = function(reelManager) {};

    this._onComplete = function() {};
}

/**
 * @returns {Promise}
 */
ReelsSpinner.prototype.spin = function() {
    var _self = this;

    this._onStart();

    var allStopped = [];

    for(var i = 0; i < this._spinReels.getReelsManagers().length; i++) {

        //console.time('r' + i);

        var reelManager = this._spinReels.getReelManager(i);
        reelManager.reinitSpeed();

        reelManager.reinitPositions();
        reelManager.reviveSpinSymbols();

        reelManager.symbolsOversetResToTmp();
        reelManager.prepareSymbolsForSpin();

        (function(reelManager) {
            reelManager.onSpin(function() {
                reelManager.blurTmpSymbols();
            });

            reelManager.onBrakeDown(function() {
                _self._onBrakeDown(reelManager);
                reelManager.unblurResSymbols();
            });

            reelManager.onBrakeUp(function() {
                _self._onBrakeUp(reelManager);
            });

            reelManager.onStop(function() {
                reelManager.removeTmpSymbols();
                _self._onStop(reelManager);
            });
        }(reelManager));

        var running = reelManager.start();
        allStopped.push(running);
    }

    this._spinReels.startSpinReels();

    return Promise.all(allStopped).then(function() {

        _self._spinReels.stopSpinReels();
//		_self._spinReels.reinitSpreaded();

//		for(var i = 0; i < _self._spinReels.getReelsManagers().length; i++) {
//			_self._spinReels.getReelManager(i).killSpinSymbols();
//		}

        _self._onComplete();
    });
};

ReelsSpinner.prototype.setOnComplete = function(func) {
    this._onComplete = func;
};

ReelsSpinner.prototype.setOnStop = function(func) {
    this._onStop = func;
};

ReelsSpinner.prototype.setOnBrakeDown = function(func) {
    this._onBrakeDown = func;
};

ReelsSpinner.prototype.setOnBrakeUp = function(func) {
    this._onBrakeUp = func;
};

ReelsSpinner.prototype.setOnStart = function(func) {
    this._onStart = func;
};